import type { ReactElement } from 'react';
import type { BindingStatus } from '@/api/v2Client';

/**
 * Form Templates tracker row 6 — whether a variable / binding will actually get
 * a value: green Resolved (with the value), amber Empty and red Broken (both
 * with the reason), grey Not checked when there is nothing selected to check
 * against. Never a green badge that was not actually checked.
 */
const STATUS_STYLE: Record<BindingStatus, { label: string; bg: string; fg: string }> = {
  resolved: { label: 'Resolved', bg: '#dcfce7', fg: '#166534' },
  empty: { label: 'Empty', bg: '#fef3c7', fg: '#b45309' },
  broken: { label: 'Broken', bg: '#fee2e2', fg: '#b91c1c' },
  unchecked: { label: 'Not checked', bg: '#f1f5f9', fg: '#475569' },
};

export function BindingStatusBadge({
  testId,
  status,
  reason,
  preview,
}: {
  testId: string;
  status: BindingStatus;
  reason?: string | undefined;
  preview?: string | undefined;
}): ReactElement {
  const s = STATUS_STYLE[status];
  return (
    <span style={{ display: 'block', marginTop: 3 }}>
      <span
        data-testid={testId}
        title={reason}
        style={{
          display: 'inline-block',
          padding: '1px 7px',
          borderRadius: 8,
          fontSize: 10,
          fontWeight: 700,
          background: s.bg,
          color: s.fg,
          marginRight: 6,
        }}
      >
        {s.label}
      </span>
      <span style={{ fontSize: 12, color: status === 'resolved' ? 'var(--text-muted)' : s.fg }}>
        {status === 'resolved' && preview !== undefined ? `→ ${preview}` : (reason ?? '')}
      </span>
    </span>
  );
}
